<template lang="html">
  <div class="">
    <div class="page-submenu">
      <div class="page-submenu_left">
        <div class="content-box">
          <left-bar></left-bar>
        </div>
      </div>
      <div class="page-submenu_right">
        <div class="content-box">
          <div class="search-content">
              <div class="search-content-fields">
                    <el-button type="primary" @click="handleAddNewClick()" >添加</el-button>
                    <el-button :disabled="selectedData.length <= 0" type="primary" @click="handleBatchDeleteClick()" plain>批量删除</el-button>
              </div>
          </div>
          <common-crud ref="crud"
            :addNewOrEditData="addNewOrEditData"
            :searchData="searchData"
            :tableData.sync="menuData"
            :crudApi="crudApi"
            editFormLabelPosition="right"
            :showPageData="false"
            :selectedDataArray.sync="selectedData"
            addSuccessMessages="添加菜单成功"
            editSuccessMessages="编辑菜单成功"
            deleteSuccessMessages="删除菜单成功"
            deleteBatchSuccessMessages="批量删除菜单成功"
          >
            <template slot="result">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column sortable prop="name" label="菜单名称">
                </el-table-column>
                <el-table-column :formatter="formatBaseData" sortable prop="menuType" label="菜单类型" width="120px">
                </el-table-column>
                <el-table-column sortable prop="url" label="路径" width="180px">
                </el-table-column>
                <el-table-column sortable prop="sortNo" label="排序" width="100px">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="130px">
                  <template slot-scope="scope">
                    <div class="table-column-operate">
                      <el-button type="text" @click="handleEditClick(scope.row)">
                        编辑
                      </el-button>
                      <el-button type="text" @click="handleDeleteClick(scope.row)">
                        删除
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
            </template>
            <template slot="editForm">
              <el-row>
                <el-col>
                  <el-form-item required label="菜单类型：" prop="menuType">
                    <el-radio-group :disabled="!!addNewOrEditData.id" v-model="addNewOrEditData.menuType">
                        <el-radio :label="0">一级菜单</el-radio>
                        <el-radio :label="1">子菜单</el-radio>
                        <el-radio :label="2">按钮/权限</el-radio>
                    </el-radio-group>
                </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item required :label="addNewOrEditData.menuType === 2?'按钮/权限：':'菜单名称：'" prop="name">
                  <el-input type="text" :placeholder="addNewOrEditData.menuType === 2?'请输入按钮/权限':'请输入菜单名称'" v-model="addNewOrEditData.name"></el-input>
                </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="addNewOrEditData.menuType != 0">
                <el-col>
                  <el-form-item required label="上级菜单：" prop="parentId">
                    <select-tree :disabled="!!addNewOrEditData.id" v-model="addNewOrEditData.parentId" :data="menuData" :props="menuTreeProps"></select-tree>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item required label="菜单路径：" prop="url">
                    <el-input type="text" placeholder="请输入菜单路径" v-model="addNewOrEditData.url"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item required label="排序：" prop="sortNo">
                    <el-input type="number" placeholder="" v-model="addNewOrEditData.sortNo"></el-input>
                  </el-form-item>     
                </el-col>
              </el-row>
            </template>
            <template slot="confirmAddNewMessage">
              <div>
                <span>确认添加？</span>
              </div>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存？</span>
              </div>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>删除菜单？</span>
              </div>
            </template>
            <template slot="confirmBatchDeleteMessage">
              <div>
                <span>批量删除菜单？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import menulist from '@/api/sysmanagement/menulist';
import LeftBar from '../LeftBar';

export default {
  components: {
    LeftBar,
  },
  data() {
    return {
      menuData: [],
      searchData: {
      },
      addNewOrEditData: {
        menuType: '',
        name:'',
        url: '',
        sortNo: '',
        parentId: '',
      },
      crudApi: menulist,
      menuTreeProps: {
            label: 'name',
            children: 'children'
        },
      selectedData: [],
    }
  },
  methods: {
    formatBaseData(row, column, cellValue, index) {
        if(column.property == 'menuType') {
            return row.menuType == 2? '按钮' : '菜单';
        }
      return '';
    },
    handleSearch() {
      this.$refs['crud'].handleSearch(1);      
    },
    handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
  },
  mounted() {    
    this.handleSearch();  
  }
};
</script>

<style lang="less" scoped>
  .search-content {
    display: flex;
    margin-bottom: 22px;

    .search-content-fields {
      width: 800px;
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?f8ddb8e0